import Delete from "@mui/icons-material/Delete";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Pencil } from "../../styles/icons/pencil";
import { useDialog } from "../../utils/hooks/use-dialog";
import { formatDatetimeShort, fromISO8601 } from "../../utils/iso8601";
import { CrudDataGrid } from "../generic/components/crud-data-grid/crud-data-grid";
import type { Columns, Row } from "../generic/components/crud-data-grid/types";
import { TagDeleteDialog } from "./tag-delete-dialog";
import { TagEditDialog } from "./tag-edit-dialog";
import type { Tag } from "./types";

export const TagCrudDataGrid: FC<{ tags: Tag[] | null; reload: () => void }> = ({
  tags,
  reload,
}) => {
  const { t } = useTranslation();
  const {
    open: editOpen,
    handleOpen: handleEditOpen,
    handleClose: handleEditClose,
    data: tagToEdit,
  } = useDialog<Tag>();
  const {
    open: deleteOpen,
    handleOpen: handleDeleteOpen,
    handleClose: handleDeleteClose,
    data: tagToDelete,
  } = useDialog<Tag>();

  const columns: Columns<Tag> = {
    name: {
      headerName: "Name",
      flex: 3,
      valueGetter: (_, row) => row.name,
    },
    created_at: {
      headerName: "Created",
      flex: 5,
      valueGetter: (_, row) => row.created_at,
      valueFormatter: (value) => (value ? formatDatetimeShort(fromISO8601(value)) : ""),
    },
  };

  if (!tags) return null;
  return (
    <>
      <CrudDataGrid<Row<Tag>>
        initialRows={tags}
        columns={columns}
        modifyActions={(actions, row) => [
          ...actions,
          ...(row
            ? [
                <GridActionsCellItem
                  key={`deletetag${row.id}`}
                  icon={
                    <Tooltip title={t("Delete")}>
                      <Delete />
                    </Tooltip>
                  }
                  label="timeline"
                  onClick={() => handleDeleteOpen(row)}
                />,
                <GridActionsCellItem
                  key={`edittag${row.id}`}
                  icon={
                    <Tooltip title={t("Edit")}>
                      <Pencil />
                    </Tooltip>
                  }
                  label="timeline"
                  onClick={() => handleEditOpen(row)}
                />,
              ]
            : []),
        ]}
      />
      {tagToDelete && (
        <TagDeleteDialog
          tag={tagToDelete}
          open={Boolean(deleteOpen)}
          handleClose={handleDeleteClose}
          reload={reload}
        />
      )}
      {tagToEdit && (
        <TagEditDialog
          tag={tagToEdit}
          open={Boolean(editOpen)}
          handleClose={handleEditClose}
          reload={reload}
        />
      )}
    </>
  );
};
